import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

/**
 * Wraps `GET /api/v1/market-data/{quote,history}`. Unlike
 * `portfolioService`/`analyticsService`, `instrument_token` here is a
 * legitimate user selection (from Instrument Search), not a fabricated
 * business input - these calls are genuinely made by the Trading page.
 */
export const quoteService = {
  async getQuote(instrumentToken: string): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.marketData.quote, {
      params: { instrument_token: instrumentToken },
    });
    return response.data;
  },
  async getHistory(instrumentToken: string, timeframe: string): Promise<ApiRecord[]> {
    const response = await apiClient.get<ApiRecord[]>(endpoints.marketData.history, {
      params: { instrument_token: instrumentToken, timeframe },
    });
    return response.data;
  },
};
